import './Content.scss'
import React from 'react'
import { Col } from 'antd'

const Content = ({ children }) => {
	return (
		<Col className="content" xs={17} sm={17} md={19} lg={19} xl={19} xxl={21}>
			<div className="content-inner">
				{ children }
			</div>
		</Col>
	)
}

export default Content
